import styled from 'styled-components';

export const CustomRadioButtonWrapper = styled.label`
  align-items: center;
  display: inline-flex;
  cursor: pointer;
`;

export const Input = styled.input`
  display: none;
`;

export const Circle = styled.div<{ isChecked: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.iconGray};
  border-radius: 9999px;
  margin-right: 10px;
  padding: 5px;
  background-color: ${({ isChecked, theme }) =>
    isChecked ? theme.colors.primary : theme.colors.iconGray};
`;

export const Radio = styled.div<{ isChecked: boolean }>`
  border-radius: 9999px;
  height: 14px;
  width: 14px;
  background-color: ${({ isChecked, theme }) =>
    isChecked ? theme.colors.white : theme.colors.iconGray};
`;
